import { useState, useEffect } from "react";
import styles from "../PlanSlider/PlanSlider.module.css";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Slider from "react-slick";
import TitleBar2 from "../../TitleBar/TitleBar2";
import createCheckoutUrl from "../../../lib/Store";

const plans = [
  {
    title: "Starter",
    minutes: "300",
    calls: "120",
    tag: "FREE VoIP Number",
    ulTitle: "Plan includes:",
    features: [
      "300 minutes / month",
      "FREE VoIP Number",
      "Agent Characterization",
      "Email Notifications",
    ],
    icon: "/Svg/Starter-Icon.svg",
    pricing: {
      US: { currency: "USD", symbol: "$", monthly: 119, yearly: 99 },
      GB: { currency: "GBP", symbol: "£", monthly: 89, yearly: 74 },
      CA: { currency: "CAD", symbol: "$", monthly: 159, yearly: 133.25 },
      AU: { currency: "AUD", symbol: "$", monthly: 179, yearly: 149.92 },
      IN: { currency: "USD", symbol: "$", monthly: 119, yearly: 99 },
    },
  },
  {
    title: "Scaler",
    minutes: "750",
    calls: "300",
    tag: "FREE VoIP Number",
    ulTitle: "Everything in Starter",
    features: [
      "750 minutes / month",
      "FREE VoIP Number",
      "Multi-Lingual with In-Call Language Switching",
      "Agent Characterization",
    ],
    popular: true,
    icon: "/Svg/Plan02.svg",
    pricing: {
      US: { currency: "USD", symbol: "$", monthly: 299, yearly: 249 },
      GB: { currency: "GBP", symbol: "£", monthly: 219, yearly: 183.25 },
      CA: { currency: "CAD", symbol: "$", monthly: 399, yearly: 333.25 },
      AU: { currency: "AUD", symbol: "$", monthly: 459, yearly: 383.25 },
      IN: { currency: "USD", symbol: "$", monthly: 299, yearly: 249 },
    },
  },
  {
    title: "Growth",
    minutes: "1500",
    calls: "600",
    tag: "FREE VoIP Number",
    ulTitle: "Everything in Starter",
    features: [
      "1500 minutes / month",
      "FREE VoIP Number",
      "Multi-Lingual with In-Call Language Switching",
      "Agent Characterization",
    ],
    icon: "/Svg/Plan03.svg",
    pricing: {
      US: { currency: "USD", symbol: "$", monthly: 599, yearly: 499 },
      GB: { currency: "GBP", symbol: "£", monthly: 439, yearly: 370.75 },
      CA: { currency: "CAD", symbol: "$", monthly: 819, yearly: 684.91 },
      AU: { currency: "AUD", symbol: "$", monthly: 919, yearly: 774.91 },
      IN: { currency: "USD", symbol: "$", monthly: 599, yearly: 499 },
    },
  },
  // {
  //   title: "Corporate",
  //   minutes: "3000",
  //   calls: "1200",
  //   tag: "FREE VoIP Number",
  //   ulTitle: "Everything in Starter",
  //   features: [
  //     "3000 minutes / month",
  //     "FREE VoIP Number",
  //     "Multi-Lingual with In-Call Language Switching",
  //     "Agent Characterization",
  //   ],
  //   icon: "/Svg/Plan04.svg",
  //   pricing: {
  //     US: { currency: "USD", symbol: "$", monthly: 999, yearly: 799 },
  //     GB: { currency: "GBP", symbol: "£", monthly: 739, yearly: 594.08 },
  //     CA: { currency: "CAD", symbol: "$", monthly: 1369, yearly: 1083.25 },
  //     AU: { currency: "AUD", symbol: "$", monthly: 1549, yearly: 1249.91 },
  //     IN: { currency: "USD", symbol: "$", monthly: 999, yearly: 799 },
  //   },
  // },
];

const PlanSlider = ({ country, onGoToSaveBig, isYearly, onToggleBilling }) => {
  console.log(country, "country of dfs");
  const [slidesToShow, setSlidesToShow] = useState(3);
  const [isMobile, setIsMobile] = useState(true);
  const [activeIndex, setActiveIndex] = useState(1);
  const [loadingPlan, setLoadingPlan] = useState(null);

  useEffect(() => {
    const handleResize = () => {
      const width = window.innerWidth;
      if (width < 899) {
        setIsMobile(true);
        setSlidesToShow(1);
      } else {
        setIsMobile(false);
        if (width < 900) setSlidesToShow(2);
        else if (width < 1100) setSlidesToShow(3);
        else setSlidesToShow(3);
      }
    };
    handleResize();
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const settings = {
    infinite: true,
    speed: 600,
    slidesToShow,
    slidesToScroll: 1,
    arrows: false,
    autoplay: true,
  };

  function getYearlySavingsText(plan, country = "US") {
    const ccRaw = (country || "US").toUpperCase();

    const key =
      ccRaw === "GB"
        ? "UK"
        : ["US", "UK", "CA", "AU"].includes(ccRaw)
        ? ccRaw
        : "US";

    const p = plan?.pricing?.[key];
    if (!p) return "";

    const monthly = Number(p.monthly);
    const yearly = Number(p.yearly);
    const percent = Math.round(((monthly - yearly) / monthly) * 100);
    const savedPerYear = (monthly - yearly) * 12;

    const locale =
      key === "UK"
        ? "en-GB"
        : key === "AU"
        ? "en-AU"
        : key === "CA"
        ? "en-CA"
        : "en-US";

    const amountText = new Intl.NumberFormat(locale, {
      style: "currency",
      currency: p.currency,
      maximumFractionDigits: 0,
    }).format(savedPerYear);

    return `You save ${percent}% (${amountText}) on Yearly billing`;
  }

  async function handleGetStarted(e, plan) {
    e?.stopPropagation?.();
    if (loadingPlan) return;
    setLoadingPlan(plan.title);
    try {
      const interval = isYearly ? "year" : "month";
      const url = await createCheckoutUrl(plan.title, interval);
      window.open(url, "_blank", "noopener,noreferrer");
    } catch (err) {
      console.error("Checkout error:", err);
      alert("Couldn't start checkout. Please try again.");
    } finally {
      setLoadingPlan(null);
    }
  }

  return (
    <div className={styles.container}>
      <div className={styles.TitleBarDiv}>
        <TitleBar2
          title="Curated Packages"
          subTitle="Polished,"
          spanText=" Predefined &"
        />
      </div>
      <div className={styles.wrapper}>
        <div className={styles.toggleRow}>
          <p className={!isYearly ? styles.activeLabel : ""}>Monthly</p>
          <div
            className={`${styles.toggleSwitch} ${
              isYearly ? styles.yearly : ""
            }`}
            onClick={onToggleBilling}
          >
            <div className={styles.circle}></div>
          </div>
          <p className={isYearly ? styles.activeLabel : ""}>Yearly</p>
        </div>

        {isYearly && (
          <div className={styles.saveBanner}>
            Save upto <strong>20%</strong> compared to monthly billing.
          </div>
        )}
      </div>

      {/* ---- Desktop View ---- */}

      {!isMobile ? (
        <div className={styles.desktopRow}>
          <div className={styles.sliderBox}>
            <Slider {...settings}>
              {plans.map((plan, i) => (
                <div key={i} className={styles.cardWrap}>
                  <div
                    className={`${styles.card} ${
                      plan.popular ? styles.popularCard : ""
                    }`}
                  >
                    {plan.popular && (
                      <div className={styles.popularTag}>
                        <img src="/Svg/plan-Notch.svg" alt="plan-Notch" />
                      </div>
                    )}
                    <div className={styles.TopBar}>
                      <div className={styles.iconTitle}>
                        <img src={plan.icon} alt={plan.title} />
                        <h3 className={styles.title}>{plan.title}</h3>
                      </div>
                      <div className={styles.priceSection}>
                        {isYearly && plan?.pricing[country]?.yearly && (
                          <p className={styles.oldPrice}>
                            {" "}
                            {plan?.pricing[country]?.symbol}
                            {plan?.pricing[country]?.monthly}
                          </p>
                        )}

                        <div>
                          <p className={styles.price}>
                            {" "}
                            {plan?.pricing[country]?.symbol}
                            {isYearly
                              ? plan?.pricing[country]?.yearly
                              : plan?.pricing[country]?.monthly}
                          </p>
                          <p className={styles.month}>
                            Monthly
                            {/* {isYearly ? "Yearly" : "Monthly"} */}
                          </p>
                        </div>
                      </div>
                    </div>

                    <div className={styles.minutesRow}>
                      <div
                        className={`${styles.colorBar} ${
                          plan.title === "Starter"
                            ? styles.pinkBar
                            : plan.title === "Scaler"
                            ? styles.purpleBar
                            : plan.title === "Growth"
                            ? styles.blueBar
                            : styles.greenBar
                        }`}
                      ></div>
                      <div className={styles.minutesInfo}>
                        <div>
                          <p className={styles.minutes}>{plan.minutes}</p>
                          <p className={styles.MinTag}>minutes</p>
                        </div>
                        <p
                          className={`${styles.tag} ${
                            plan.title === "Starter"
                              ? styles.pinkTag
                              : plan.title === "Scaler"
                              ? styles.purpleTag
                              : plan.title === "Growth"
                              ? styles.blueTag
                              : styles.greenTag
                          }`}
                        >
                          {plan.tag}
                        </p>
                      </div>
                    </div>

                    <div className={styles.PlanUlTitle}>
                      <p>{plan.ulTitle}</p>
                    </div>

                    <ul className={styles.features}>
                      {plan.features.map((f, idx) => (
                        <li key={idx}>✓ {f}</li>
                      ))}
                    </ul>

                    <div className={styles.saveNote}>
                      {getYearlySavingsText(plan, country)}
                    </div>
                    <div
                      className={styles.standardFeature}
                      role="button"
                      tabIndex={0}
                      onClick={() => onGoToSaveBig?.(plan.title)}
                      onKeyDown={(e) =>
                        (e.key === "Enter" || e.key === " ") &&
                        onGoToSaveBig?.(plan.title)
                      }
                    >
                      <p>+ Standard Feature</p>
                    </div>
                    <button
                      className={styles.btn}
                      type="button"
                      onClick={(e) => handleGetStarted(e, plan)}
                      disabled={loadingPlan === plan.title}
                    >
                      <p>
                        {loadingPlan === plan.title
                          ? "Loading..."
                          : "Get Started"}
                      </p>
                    </button>
                  </div>
                </div>
              ))}
            </Slider>
          </div>
          {/* RIGHT FIXED CARD */}
          <div className={styles.rexptLiteCard}>
            <div className={styles.LiteTopBar}>
              <div>
                <h3 className={styles.rexTitle}>Rexpt Lite</h3>
                <img src="/Svg/line.svg" alt="line" />
              </div>
              <div className={styles.freetitle}>
                <h3 className={styles.free}>FREE</h3>
                <p className={styles.noRestrictions}>no restrictions</p>
              </div>
            </div>

            <div className={styles.signUpBox}>
              <h4>Sign up for FREE</h4>
              <p>
                Includes FREE 20 min + CUSTOM AGENT + VoIP Number + Standard
                features
              </p>
            </div>
            
            <img src="/Svg/lite-plan-icon.svg" alt="lite-plan-icon" />
            <button
              className={styles.freeBtn}
              onClick={() => window.open("https://app.rxpt.ai/", "_blank")}
            >
              FREE SIGNUP
            </button>

            <p className={styles.note}>
              Get the most <a href="">Intelligent & Pre-Trained</a>{" "}
              Receptionist, Superfast!
            </p>
          </div>
        </div>
      ) : (
        <div className={styles.mobileList}>
          {plans.map((plan, i) => (
            <div
              key={i}
              className={`${styles.mobileCard} ${
                activeIndex === i ? styles.activeCard : ""
              }`}
            >
              <div
                className={styles.mobileHeader}
                onClick={() => setActiveIndex(activeIndex === i ? null : i)}
              >
                <div className={styles.mobileHeaderLeft}>
                  <img
                    src={plan.icon}
                    alt={plan.title}
                    className={styles.planIcon}
                  />
                  <div>
                    <h3>{plan.title}</h3>
                    <p className={styles.calls}>{plan?.calls} calls handled</p>
                  </div>
                </div>

                <div className={styles.mobileHeaderRight}>
                  <div>
                    <p className={styles.price}>
                      {" "}
                      {plan?.pricing[country]?.symbol}
                      {isYearly
                        ? plan?.pricing[country]?.yearly
                        : plan?.pricing[country]?.monthly}
                    </p>
                    <p className={styles.month}>Monthly</p>
                  </div>
                  <span
                    className={`${styles.arrow} ${
                      activeIndex === i ? styles.arrowUp : styles.arrowDown
                    }`}
                  ></span>
                </div>
              </div>

              {activeIndex === i && (
                <div className={styles.mobileBody}>
                  <div className={styles.DFLex}>
                    <div className={styles.minutesBox}>
                      <div
                        className={`${styles.colorBar} ${styles.pinkBar}`}
                      ></div>
                      <span className={styles.minutesNum}>
                        {plan.minutes} <p>minutes</p>
                      </span>
                    </div>
                    <div className={styles.featureTags}>
                      {plan.features.slice(0, 2).map((f, idx) => (
                        <span key={idx} className={styles.featureTag}>
                          {f}
                        </span>
                      ))}
                    </div>
                  </div>

                  <div className={styles.saveBox}>
                    {getYearlySavingsText(plan, country)}
                  </div>
                  <div
                    className={styles.standardFeature}
                    role="button"
                    tabIndex={0}
                    onClick={() => onGoToSaveBig?.(plan.title)}
                    onKeyDown={(e) =>
                      (e.key === "Enter" || e.key === " ") &&
                      onGoToSaveBig?.(plan.title)
                    }
                  >
                    + Standard Feature
                  </div>
                  <button
                    className={styles.btn}
                    type="button"
                    onClick={(e) => handleGetStarted(e, plan)}
                    disabled={loadingPlan === plan.title}
                  >
                    <p>
                      {loadingPlan === plan.title
                        ? "Loading..."
                        : "Get Started"}
                    </p>
                  </button>
                </div>
              )}
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default PlanSlider;
